<template>
    <div class="consultas-produtos-cliente">
        <g-card class="card-consultas-produtos-cliente" 
        :expansivel="false" 
        :temCabecalho="false" 
        :temBordaTopProps="false"
        >
            <div class="conteudo-detalhes-cliente espacamento-pdf">
                <div class="titulo-grupo-detalhes"> DADOS DO CLIENTE </div>
                <div class="grupo-dados-cliente">
                    <div class="cliente-unidade">
                        <div class="titulo-conteudo-detalhes"> Unidade </div>
                        <div class="label-conteudo">{{ InformacoesClienteSelecionado.nomeEmpresa }}</div>
                    </div>

                    <div class="cliente-representante">
                        <div class="titulo-conteudo-detalhes"> Vendedor / Representante </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.nomeRepresentante}}</div>
                    </div>

                    <div class="cliente-razao-social">
                        <div class="titulo-conteudo-detalhes"> Razão Social </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.razaoSocial}}</div>
                    </div>
                        
                    <div class="cliente-inscricao">
                        <div class="dados_cliente_inscricao titulo-conteudo-detalhes"> Inscrição estadual</div>
                        <div class="dados_cliente_inscricao_label-conteudo label-conteudo">{{InformacoesClienteSelecionado.inscricaoEstadual || 'Não Cadastrado'}}</div>
                    </div>

                    <div class="cliente-cnpj">
                        <div class="titulo-conteudo-detalhes"> CNPJ </div>
                        <PInputMask v-model="InformacoesClienteSelecionado.cnpj " mask="99.999.999/9999-99" class="input-mask-escondido">  </PInputMask>
                        <div class="label-conteudo"  mask="99.999.999/9999-99">{{InformacoesClienteSelecionado.cnpj}}</div>
                    </div>

                    <div class="cliente-nome-fantasia">
                        <div class="titulo-conteudo-detalhes"> Nome Fantasia </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.nomeFantasia}}</div>
                    </div>

                    <div class="cliente-situacao">
                        <div class="titulo-conteudo-detalhes"> Situação </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.clienteSituacaoTexto}}</div>
                    </div>

                    <div class="cliente-segmento">
                        <div class="titulo-conteudo-detalhes"> Segmento </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.clienteTipoTexto}}</div>
                    </div>

                    <div class="cliente-curva">
                        <div class="titulo-conteudo-detalhes"> CV </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.curvaCliente || 'Não Possui'}}</div>
                    </div>

                    <div class="cliente-email">
                        <div class="titulo-conteudo-detalhes"> E-mail Nfe </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.emailNFE || 'Não cadastrado'}}</div>
                    </div>

                    <div class="cliente-cidade-estado">
                        <div class="titulo-conteudo-detalhes"> Cidade / Estado </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.estadoCidade}}</div>
                    </div>
                </div>

                <div class="titulo-grupo-detalhes"> DADOS FISCAIS </div>
                <div class="grupo-dados-fiscais">
                    <div class="fiscais-agrupador">
                        <div class="titulo-conteudo-detalhes"> Cliente agrupador </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.nomeClienteAgrupador}}</div>
                    </div>
    
                    <div class="fiscais-suframa">
                        <div class="titulo-conteudo-detalhes"> Suframa </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.numeroSuframa == 0 ? 'Não Possui' : InformacoesClienteSelecionado.numeroSuframa}}</div>
                    </div>

                    <div class="fiscais-suspensao-ipi">
                        <div class="titulo-conteudo-detalhes"> Possui suspensão de IPI? </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.ipi ? 'Possui' : 'Não Possui'}}</div>
                    </div>

                    <div class="fiscais-zona-franca">
                        <div class="titulo-conteudo-detalhes"> Zona Franca </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.zonaFranca ? 'Possui' : 'Não Possui' }}</div>
                    </div>

                    <div class="fiscais-codigo-acesso">
                        <div class="titulo-conteudo-detalhes"> Exige código de acesso na nota fiscal? </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.exigeOrdemAcessoNaNF ? 'Sim' : 'Não'}}</div>
                    </div>

                    <div class="fiscais-incentivo-icms">
                        <div class="titulo-conteudo-detalhes"> Possui incentivo fiscal - Diferimento de ICMS?</div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.icms ? 'Sim' : 'Não'}}</div>
                    </div>

                    <div class="fiscais-ordem-compra">
                        <div class="titulo-conteudo-detalhes"> Exige ordem de compra na nota fiscal? </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.exigeOrdemCompraNaNF ? 'Sim' : 'Não'}}</div>
                    </div>

                    <div class="fiscais-incentivo-pis">
                        <div class="titulo-conteudo-detalhes"> Possui incentivo fiscal - Diferimento de PIS/COFINS? </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.pisCofins ? 'Sim' : 'Não' }}</div>
                    </div>

                    <div class="fiscais-quantidade">
                        <div class="titulo-conteudo-detalhes"> Quantidade </div>
                        <div class="label-conteudo">{{InformacoesClienteSelecionado.quantidade}}</div>
                    </div>
                </div>
                <div class="html2pdf__page-break" />
    
                <div class="titulo-grupo-detalhes"> CONTATO </div>
                <div class="grupo-dados-contato" v-for="contato in InformacoesClienteSelecionado.contatos" :key="contato.id">
                    <div class="contato-telefone">
                        <div class="titulo-conteudo-detalhes"> Telefone </div>
                        <div class="label-conteudo">{{ contato.numeroTelefone || 'Não Cadastrado'}}</div>                    
                    </div>

                    <div class="contato-celular">
                        <div class="titulo-conteudo-detalhes"> Celular </div>
                        <div class="label-conteudo">{{ contato.numeroCelular|| 'Não Cadastrado' }}</div>
                    </div>

                    <div class="contato-email_pdf">
                        <div class="titulo-conteudo-detalhes"> Email </div>
                        <div class="label-conteudo">{{ contato.email || 'Não Cadastrado' }}</div>
                    </div>

                    <div class="contato-site">
                        <div class="titulo-conteudo-detalhes"> Site </div>
                        <div class="label-conteudo">{{ contato.clienteSite || 'Não Cadastrado' }}</div>
                    </div>
                </div>

                <div class="cliente-label label-conteudo" v-if="!this.TemInformacoesContato"> Cliente não possui nenhum contato cadastrado </div>
  
                <div class="titulo-grupo-detalhes"> ENDEREÇO </div>
                <div class="grupo-dados-endereco" v-for="enderecos in InformacoesClienteSelecionado.enderecos" :key="enderecos.id">
                    <div class="endereco-endereco">
                        <div class="titulo-conteudo-detalhes"> Endereço </div>
                        <div class="label-conteudo">{{ enderecos.endereco  || 'Não cadastrado'}}</div>
                    </div>

                    <div class="endereco-cidade-estado">
                        <div class="titulo-conteudo-detalhes"> Cidade / Estado </div>
                        <div class="label-conteudo">{{enderecos.nomeCidade}} - {{enderecos.siglaEstado}}</div>
                    </div>

                    <div class="endereco-bairro">
                        <div class="titulo-conteudo-detalhes"> Bairro </div>
                        <div class="label-conteudo">{{ enderecos.bairro || 'Não Cadastrado'}}</div>
                    </div>

                    <div class="endereco-cep">
                        <div class="titulo-conteudo-detalhes"> CEP </div>
                        <div class="label-conteudo">{{ enderecos.cep}}</div>
                    </div>

                    <div class="endereco-complemento">
                        <div class="titulo-conteudo-detalhes">Complemento</div>
                        <div class="label-conteudo">{{ enderecos.complemento || 'Não Cadastrado'}}</div>
                    </div>
                </div>     
                
                
                <div class="cliente-label label-conteudo" v-if="!this.TemInformacoesEndereco"> Não há endereços cadastrados para este cliente! </div>
                
                <div v-if="this.quebraEndereco && this.quebraContato" >
                    <div class="html2pdf__page-break"/>
                </div>
                <div class="titulo-grupo-detalhes"> CRÉDITO </div>
                <div class="grupo-dados-credito" v-if="this.TemInformacoesCredito">
                    <div class="credito-ultima-compra">
                        <div class="titulo-conteudo-detalhes"> Última compra </div>
                        <div class="label-conteudo">{{(InformacoesClienteCreditoSelecionado.dataUltimoFaturamentoFormatada || ' ')+ ' - ' + 'R$ ' + (InformacoesClienteCreditoSelecionado.valorUltimoFaturamentoFormatado || '0,00')}}</div>
                    </div>

                    <div class="credito-ultimo-pagamento">
                        <div class="titulo-conteudo-detalhes"> Último pagamento </div>
                        <div class="label-conteudo">{{(InformacoesClienteCreditoSelecionado.dataUltimoPagamentoFormatada || '  ' )+ ' - ' + 'R$ ' + (InformacoesClienteCreditoSelecionado.valorUltimoPagamentoFormatado || '0,00')}}</div>
                    </div>

                    <div class="credito-maior-faturamento">
                        <div class="titulo-conteudo-detalhes"> Maior faturamento </div>
                        <div class="label-conteudo">{{( InformacoesClienteCreditoSelecionado.dataMaiorFaturamentoFormatada || '  ' ) + ' - ' + 'R$ ' + (InformacoesClienteCreditoSelecionado.valorMaiorFaturamentoFormatada || '0,00')}}</div>
                    </div>

                    <div class="credito-maior-acumulo">
                        <div class="titulo-conteudo-detalhes"> Maior acúmulo </div>
                        <div class="label-conteudo">{{( InformacoesClienteCreditoSelecionado.dataMaiorAcumuloFormatada || '  ' ) + ' - ' + 'R$ ' + (InformacoesClienteCreditoSelecionado.valorMaiorAcumuloFormatado || '0,00') }}</div>
                    </div>

                    <div class="credito-titulos-aberto">
                        <div class="titulo-conteudo-detalhes"> Títulos em aberto </div>
                        <div class="label-conteudo">{{'R$ ' + (InformacoesClienteCreditoSelecionado.valorTitulosEmAbertoFormatado || '0,00') }}</div>
                    </div>

                    <div class="credito-titulos-vencidos">
                        <div class="titulo-conteudo-detalhes"> Títulos vencidos </div>
                        <div class="label-conteudo">{{'R$ ' + (InformacoesClienteCreditoSelecionado.valorTitulosVencidosFormatado || '0,00')}}</div>
                    </div>

                    <div class="credito-titulos-vencer">
                        <div class="titulo-conteudo-detalhes"> Títulos à vencer </div>
                        <div class="label-conteudo">{{'R$ ' + (InformacoesClienteCreditoSelecionado.valorTitulosAVencerFormatado || ' ')}}</div>
                    </div>

                    <div class="credito-titulos-protestados">
                        <div class="titulo-conteudo-detalhes"> Possui títulos protestados </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.titulosProtestados == false ? 'Não' : 'Sim'}}</div>
                    </div>

                    <div class="credito-parcelas-dia">
                        <div class="titulo-conteudo-detalhes"> Parcelas pagas em dia </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.diasParcelasPagas}}</div>
                    </div>

                    <div class="credito-parcelas-atraso">
                        <div class="titulo-conteudo-detalhes"> Parcelas pagas em atraso </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.diasParcelasAtraso}}</div>
                    </div>

                    <div class="credito-media-atraso">
                        <div class="titulo-conteudo-detalhes"> Média de atraso </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.quantidadeDiasAtrasoMedio}}</div>
                    </div>

                    <div class="credito-pedidos-aberto">
                        <div class="titulo-conteudo-detalhes"> Pedidos em aberto </div>
                        <div class="label-conteudo">{{'R$ ' + (InformacoesClienteCreditoSelecionado.valorPedidosEmCarteiraFormatado || '0,00')}}</div>
                    </div>

                    <div class="credito-valor-limite">
                        <div class="titulo-conteudo-detalhes"> Valor do limite de crédito </div>
                        <div class="label-conteudo">{{'R$ ' + (InformacoesClienteCreditoSelecionado.valorLimiteCreditoFormatado || '0,00')}}</div>
                    </div>

                    <div class="credito-data-atualizacao">
                        <div class="titulo-conteudo-detalhes"> Data atualização </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.alteracaoFormatada || 'Não Possui'}}</div>
                    </div>

                    <div class="credito-data-validade-limite">
                        <div class="titulo-conteudo-detalhes"> Data da validade do limite de crédito </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.dataValidadeLimiteCreditoFormatada || 'Não Possui'}}</div>
                    </div>

                    <div class="credito-data-observacoes">
                        <div class="titulo-conteudo-detalhes"> Observação </div>
                        <div class="label-conteudo">{{InformacoesClienteCreditoSelecionado.observacao || 'Não Possui'}}</div>
                    </div>
                </div>

                <div v-if="!this.TemInformacoesCredito" class="cliente-label label-conteudo"> Cliente não possui informações de crédito </div>
            </div>
        </g-card>
    </div>
</template>


<script>
import PDFClienteInformacao from './PDFClienteInformacao.js' 
export default PDFClienteInformacao
</script>

<style scoped>
.grupo-dados-cliente{
    display: grid;
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    column-gap: 3%;
}
.grupo-dados-fiscais{
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
    column-gap: 3%;
}
.label-conteudo_email{
    width: 100%;
    white-space: pre-wrap;
}
.grupo-dados-contato{
    display: grid;
    grid-template-columns: 0.5fr 0.5fr 1fr 0.75fr;
    grid-template-rows: repeat(1, auto);
    column-gap: 3%;
}
.grupo-dados-credito{
    display: grid;
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
    column-gap: 3%;
}
.grupo-dados-endereco{
    display: grid;
    grid-template-columns: repeat(5, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
    column-gap: 3%;
}
.input-mask-escondido{
    display: none;
}

    hr:not([size]) {
        height: 1px;
        margin-top: 38px;
    }

.cliente-label {
    margin-top: 10px;
}

@media (min-width:310px) {}

@media (min-width:368px) {
}

@media (min-width:450px) {}

@media (min-width:600px) {}

@media (min-width:801px) {}

@media (min-width:1025px) { }

@media (min-width:1281px) { }

@media (min-width:1700px) { }

@media (min-width:1800px) { }
</style>
